export const WOA_PLATFORM_LIST = [
  {
    title: 'Bugly监控定位',
    src: 'https://bugly.woa.com/v2/index/main',
  },
  {
    title: '智能低代码',
    src: 'https://xy.woa.com/xy/app/prod/portal/index',
  },
  {
    title: 'TDF端框架',
    src: 'https://tdf.woa.com',
  },
  {
    title: 'Shiply全场景发布',
    src: 'https://shiply.tds.woa.com/',
  },
  {
    title: 'Rightly应用合规',
    src: 'https://docs.bugly.woa.com/rightly/rightly_intro',
  },
  {
    title: 'RAFT组件市场',
    src: 'https://raftx.woa.com/',
  },
  {
    title: 'More >>',
    src: 'https://tds-home.woa.com/v1',
  },
];

export const TDS_QQ_PLATFORM_LIST = [
  {
    title: '监控定位',
    src: 'https://bugly.tds.qq.com/v2/index/tds-main',
  },
  {
    title: '智能低代码',
    src: 'https://wujicode.cn/xy/app/prod/official/index',
  },
  {
    title: '跨平台框架',
    src: 'https://framework.tds.qq.com/',
  },
  {
    title: '全场景发布',
    src: 'https://shiply.tds.qq.com/',
  },
  {
    title: '应用合规',
    src: 'https://rightly.tds.qq.com',
  },
];

export const TEST_TDS_QQ_PLATFORM_LIST = [
  {
    title: '监控定位',
    src: 'https://t.bugly.tds.qq.com/v2/index/tds-main',
  },
  {
    title: '智能低代码',
    src: 'https://test1.u.wujicode.cn/page/index',
  },
  {
    title: '跨平台框架',
    src: 'https://t.framework.tds.qq.com/',
  },
  {
    title: '全场景发布',
    src: 'https://test.shiply.tds.qq.com/',
  },
  {
    title: '应用合规',
    src: 'https://test.rightly.tds.qq.com',
  },
];
export const DEFAULT_ICP = '粤B2-20090059';
export const DEFAULT_ICP_URL = 'https://beian.miit.gov.cn/#/Integrated/index';
export const TDS_HOME_URL = 'https://tds-home.woa.com/v1';
export const TDS_QQHOME_URL = 'https://tds.qq.com';
export const TEST_TDS_QQHOME_URL = 'https://t.tds.qq.com';
